import type { NoteReminder } from '../hooks/fragment';
import type { CreateNoteReminderArgs } from '../hooks/useCreateNoteReminder';

type ReminderTarget = NonNullable<NoteReminder['reminderTarget']>;

interface GenerateEventBasedNoteReminderParameters {
  companyId: string;
  noteId: string;
  operationType: string;
  targetMetadata?: ReminderTarget['targetMetadata'];
  targetSharePrice: number;
  userTimezone: string;
}

export function generateEventBasedNoteReminderPayload({
  companyId,
  noteId,
  operationType,
  targetMetadata,
  targetSharePrice,
  userTimezone,
}: GenerateEventBasedNoteReminderParameters) {
  const eventBasedReminderPayload = {
    eventType: 'price_updates',
    objectIdentifier: companyId,
    operationType,
    targetKey: 'last_share_price',
    targetMetadata,
    targetValue: targetSharePrice,
  };

  const createNoteReminderPayload: CreateNoteReminderArgs = {
    eventBasedReminder: eventBasedReminderPayload,
    noteId,
    userTimezone,
  };

  return createNoteReminderPayload;
}
